import FloatingTooltip from "@components/common/FloatingTooltip";
import TravelTimeline from "./TravelTimeline";
import { Journey } from "@gen/travel/v1/common_pb";
import { GhgTag } from "./GHGTag";

type DetailedTimelineProps = {
  journey: Journey;
  type: string;
};

export default function DetailedTimeline({ journey }: DetailedTimelineProps) {
  return journey.segments.map((segment, index) => (
    <div key={index}>
      <TravelTimeline journey={segment}>
        <div className="flex justify-center">
          <GhgTag value={journey.ghgEmission} />
          {segment.transport?.logo && (
            <FloatingTooltip content={segment.transport.name}>
              <img
                src={segment.transport.logo}
                alt="carrier-logo"
                className="ml-1 max-w-[80px]"
              />
            </FloatingTooltip>
          )}
        </div>
      </TravelTimeline>
    </div>
  ));
}
